module.exports = __webpack_public_path__ + "static/media/picture7.77c3cab9.png";